import { Component, Input } from '@angular/core';
import { EnvironmentVariablesService } from '@kenv';
import { productDisplayName } from '@kservice';

@Component({
  selector: 'kp-version-tag',
  templateUrl: './version-tag.component.html',
  styleUrls: ['./version-tag.component.scss'],
})
export class VersionTagComponent {
  @Input() hidden = false;

  constructor(private _environmentVariablesService: EnvironmentVariablesService) {}

  appVersion = this._environmentVariablesService.versions.app[this._environmentVariablesService.product];
  npmVersion = this._environmentVariablesService.versions.npm_version;
  version = this._environmentVariablesService.latestVersion;
  revision = this._environmentVariablesService.versions.revision;
  product = productDisplayName;
}
